import(/* webpackMode: "eager", webpackExports: ["ServiceWorkerRegistration"] */ "/vercel/path0/components/ServiceWorkerRegistration.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AppErrorBoundary"] */ "/vercel/path0/src/components/common/AppErrorBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/ErrorMonitoringV2.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalThemeToggle"] */ "/vercel/path0/src/components/common/GlobalThemeToggle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationTracker"] */ "/vercel/path0/src/components/monitoring/NavigationTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PreferencesProvider"] */ "/vercel/path0/src/contexts/preferences-context.tsx");
